'use client'

import { ReactNode } from 'react'
import type { LucideIcon } from 'lucide-react'

interface PageHeaderProps {
  /** Accepted but not rendered — kept so call sites need no changes. */
  icon?: LucideIcon
  /** Accepted but not rendered — illustrations were removed app-wide. */
  illustration?: string
  /** Accepted but unused — kept for back-compat with older call sites. */
  crumb?: string
  title: string
  subtitle?: ReactNode
  actions?: ReactNode
  /** Optional row rendered below the title row (e.g. tabs, filters). */
  children?: ReactNode
}

/**
 * Compact page header used at the top of every page.
 *
 *   ┌──────────────────────────────────────────────────────────┐
 *   │  Title                                  [actions buttons]│
 *   │  Small subtitle                                          │
 *   └──────────────────────────────────────────────────────────┘
 *
 * No card chrome, no illustration, no breadcrumb — just a small
 * editorial title block with optional actions on the right.
 */
export function PageHeader({
  title, subtitle, actions, children,
}: PageHeaderProps) {
  return (
    <div className="of-page-hero-wrap">
      <div className="of-page-hero">
        <div className="of-page-hero-text">
          <h1 className="of-page-hero-h1">{title}</h1>
          {subtitle != null && subtitle !== '' && (
            <div className="of-page-hero-subtitle">{subtitle}</div>
          )}
        </div>
        {actions && <div className="of-page-hero-actions">{actions}</div>}
      </div>
      {children && <div className="of-page-hero-controls">{children}</div>}
    </div>
  )
}
